export default "__VITE_ASSET__CxhHQLhr__"